import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar.js';
import Footer from './components/Footer.js';
import Home from './pages/Home.js';
import About from './pages/About.js';
import WhatWeDo from './pages/WhatWeDo.js';
import PartnersSponsors from './pages/PartnersSponsors.js';
import Contact from './pages/Contact.js';
import LegalCompliance from './pages/LegalCompliance.js';
import PrivacyPolicy from './pages/PrivacyPolicy.js';
import TermsOfUse from './pages/TermsOfUse';
import PartnerDisclaimer from './pages/PartnerDisclaimer';
import OurExperiences from './pages/OurExperience.js';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/experiences" element={<OurExperiences />} />
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/partners-sponsors" element={<PartnersSponsors />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal-compliance" element={<LegalCompliance />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/partner-disclaimer" element={<PartnerDisclaimer />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;